import React, { ReactElement } from 'react';
import { FormControlError } from '../../../core/shared/forms/useForm';
import { NonEmptyArray } from '../../../utils/types';
import { CheckBox } from '../checkbox/CheckBox';

interface IProps {
  label: string | ReactElement;
  checked: boolean;
  disabled?: boolean;
  onChange: (value: boolean) => void;
  errors?: NonEmptyArray<FormControlError>;
}
export const CheckBoxField: React.FC<IProps> = ({
  checked,
  onChange,
  disabled,
  label,
  errors,
}) => {
  return (
    <div className="login__form__field__row login__form__field__row--no_margin_bottom">
      <CheckBox
        checked={checked}
        disabled={disabled}
        errors={errors}
        onChange={(v) => {
          onChange(v);
        }}
      />
      <label className="login__form__field__row__label">{label}</label>

      {!!errors?.length && (
        <p className="assistive_text assistive_text--error">
          {errors.map(({ message }) => message).join(', ')}
        </p>
      )}
    </div>
  );
};
